import { AuthenticationService } from '../authentication.service';
import { getAuthenUrl } from '../authentication.utils';
import { HTTP_SERVICE, IHttpError, IHttpService } from '../../http';
import { IAuthenticationService, ILoginResponse } from '../authentication.interface';
import { IAuthenticationTokens, IError, IJWT } from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { USER_01 } from '../../../mocks/user.data';

@injectable()
export class BasicAuthenticationService extends AuthenticationService implements IAuthenticationService {

    @inject(HTTP_SERVICE) private readonly httpSrv: IHttpService;

    login(userId: string, password: string): Promise<[ IJWT, IError? ]> {
        const body = {
            user: userId,
            password: password,
        };

        return this.httpSrv.post<ILoginResponse>(getAuthenUrl(), body)
            .then(([ data, error ]: [ ILoginResponse, IHttpError ]) => {
                if (Boolean(error)) {
                    return [ undefined, {
                        type: 'Technical',
                        code: error.code,
                        message: error.message,
                    } ];
                } else if (Boolean(data.error)) {
                    return [ undefined, {
                        type: 'Functional',
                        message: data.error,
                    } ];
                }

                const user = {
                    // TODO: Why do we mix user data with mocked data ???
                    ...USER_01,
                    id: userId,
                };

                const tokens: IAuthenticationTokens = {
                    user_id: user.id,
                    token_type: 'token',
                    access_token: data.token,
                };
                sessionStorage.setItem('SFX_IS_LOGGED', 'true');
                sessionStorage.setItem('SFX_TOKENS', JSON.stringify(tokens));
                sessionStorage.setItem('USER', JSON.stringify(user));
                sessionStorage.setItem('SFX_AUTH_MODE', 'form');

                return [ data.token ];
            });
    }
}
